"use client";

import { useCallback } from "react";
import { FrontendEvent } from "@artha/types";
import { useAnalytics } from "@/lib/analytics/useAnalytics";

export function useReferralAnalytics() {
  const { trackEvent } = useAnalytics();

  const trackReferAndEarnOpened = useCallback(() => {
    trackEvent(FrontendEvent.CR_REFER_AND_EARN);
  }, [trackEvent]);

  const trackReferAndEarnCopyLink = useCallback(() => {
    trackEvent(FrontendEvent.CR_REFER_AND_EARN_COPYLINK);
  }, [trackEvent]);

  const trackReferAndEarnShare = useCallback(
    (socialMedia: string) => {
      trackEvent(FrontendEvent.CR_REFER_AND_EARN_SHARE, {
        social_media: socialMedia,
      });
    },
    [trackEvent]
  );

  const trackReferAndEarnWhatsAppInvite = useCallback(() => {
    trackEvent(FrontendEvent.CR_REFER_AND_EARN_WHATSAPPINVITE);
  }, [trackEvent]);

  const trackReferAndEarnResourcesPlaybook = useCallback(() => {
    trackEvent(FrontendEvent.CR_REFER_AND_EARN_RESOURCES_PLAYBOOK);
  }, [trackEvent]);

  const trackReferAndEarnResourcesIdea = useCallback(() => {
    trackEvent(FrontendEvent.CR_REFER_AND_EARN_RESOURCES_IDEA);
  }, [trackEvent]);

  const trackReferAndEarnResourcesVideo = useCallback(() => {
    trackEvent(FrontendEvent.CR_REFER_AND_EARN_RESOURCES_VIDEO);
  }, [trackEvent]);

  const trackReferAndEarnInvitation = useCallback(
    (creatorUniqueId: string) => {
      trackEvent(FrontendEvent.REFER_AND_EARN_INVITATION, {
        creatorunique_id: creatorUniqueId,
      });
    },
    [trackEvent]
  );

  return {
    trackReferAndEarnOpened,
    trackReferAndEarnCopyLink,
    trackReferAndEarnShare,
    trackReferAndEarnWhatsAppInvite,
    trackReferAndEarnResourcesPlaybook,
    trackReferAndEarnResourcesIdea,
    trackReferAndEarnResourcesVideo,
    trackReferAndEarnInvitation,
  };
}
